"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  function accept() {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  }

  function decline() {
    localStorage.setItem(STORAGE_KEY, "declined");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6">
      <div
        className="mx-auto flex max-w-4xl flex-col gap-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-2xl sm:flex-row sm:items-center sm:gap-6"
        style={{ boxShadow: "0 -4px 40px rgba(0,0,0,0.12)" }}
      >
        <div className="flex items-start gap-3 sm:flex-1">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-amber-100">
            <Cookie size={18} className="text-amber-600" />
          </div>
          <div>
            <p className="text-sm font-semibold text-slate-800">Ce site utilise des cookies</p>
            <p className="mt-0.5 text-xs leading-relaxed text-slate-500">
              Nous utilisons uniquement des cookies techniques nécessaires au fonctionnement du site.
              Aucun cookie publicitaire ou de traçage n'est utilisé.{" "}
              <Link href="/politique-confidentialite" className="font-medium text-slate-700 underline hover:text-slate-900">
                En savoir plus
              </Link>
            </p>
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <button
            onClick={decline}
            className="rounded-xl border border-slate-200 px-4 py-2 text-sm text-slate-600 transition hover:bg-slate-50"
          >
            Refuser
          </button>
          <button
            onClick={accept}
            className="rounded-xl bg-[#1a2744] px-4 py-2 text-sm font-medium text-white transition hover:bg-[#1e3a5f]"
          >
            Accepter
          </button>
          <button onClick={decline} className="text-slate-400 hover:text-slate-600 ml-1" aria-label="Fermer">
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
